import { useEffect } from "react"

import { applyTheme, getStoredTheme, initializeTheme } from "@/lib/theme"

export function ThemeInitializer() {
  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)")

    const handleMediaChange = () => {
      if (getStoredTheme() === "system") {
        applyTheme("system")
      }
    }

    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === "theme") {
        initializeTheme()
      }
    }

    initializeTheme()

    mediaQuery.addEventListener("change", handleMediaChange)
    window.addEventListener("storage", handleStorageChange)

    return () => {
      mediaQuery.removeEventListener("change", handleMediaChange)
      window.removeEventListener("storage", handleStorageChange)
    }
  }, [])

  return null
}
